




















































































import { Component, Prop, Vue } from 'vue-property-decorator';
import SearchResult from '@/components/startup/SearchResult.vue';


@Component({
  components: {
    SearchResult,
  },
})
export default class Search extends Vue {
  @Prop() private msg!: string;

  techFieldSelected = ''

  bussinessApplicationSelected = ''

  demand = ''

  keyword = ''

  techField = [
    'AI',
    'Blockchain',
    'Data Analysis',
    'ビッグデータ',
    '情報セキュリティ',
    '5G・通信技術',
    'VR・AR・MR',
    'クラウド',
    'プラットフォーム',
    'アイオーティー',
    'サース',
  ];

  bussinessApplication = [
    'ビジネスツール系',
    'ものづくり・製造系',
    '人事・労働系',
    '金融・保険系',
    '不動產系',
    '教育系',
    '広告系',
    '流通・小売系',
    '飲食系',
    'スマートホーム系',
    'ファッション系',
    'エンターテイメン系',
    'スポーツ系',
    'ヘルスケア系',
    '医療系',
    '農業系',
    '環境・エネルジー系',
    '交通系',
    '公共系',
    '政府系',
    '技術系',
    'その他',
  ];

  detailToggle = false;

  searchResult = [
    {
      image: 'logo.png',
      tag: '#フィンテック #B2B #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド完了した',
      number: 'SLTW001',
      companyName: 'デジタル・アイデンティティ技術がもっと早く、もっと使いやすい、もっと安全安心',
      description: `
      情報セキュリティのスタートアップとして、本人確認書類及び顔の認証システムを提供しております。
      優良な認証システム、顔認証システム及び生体検知技術を通じて、企業方にとってコストを下げますし、
      ユーザー体験の向上に生かせます。

      銀行・保険業の店頭でのサービス及びリモードサービス、自動販売機や無人貸出レンタカーなど
      場合にうちのデジタル・アイデンティティ技術を有効に活用できます。`,
      investmentDemand: '業務提携、資本提携',
      established: '2019',
      capitalInvestment: '500万台湾ドル（約1,800万円）',
      employees: '--',
      revenue: '約5400万円',
    },
    {
      image: 'logo.png',
      tag: '#医療テック #B2B #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド完了した',
      number: 'SLTW002',
      // 為癌症病人做進一步的篩藥，迅速找到適合病人的抗癌藥物
      companyName: 'がん患者のためのさらなるスクリーニングを行い、患者に適した抗癌剤を迅速に見つける',
      // // 專注於循環腫瘤細胞(Circulating tumor cells, CTCs）的活細胞分析，
      // 致力於研發個人化抗癌藥物檢測服務，透過仿生腫瘤類器官培養系統，
      // 協助醫生和患者制定最佳治療策略，以在各個階段對抗癌症並降低無效用藥的機率。
      description: `循環腫瘍細胞(Circulating tumor cells, CTC)の生細胞分析に注力し、
      バイオニック腫瘍臓器培養システムを通じて、医師や患者があらゆる段階で癌と戦い、
      効果的な薬物使用の可能性を低減するための最適な治療戦略を開発するのを支援する
      パーソナライズされた抗癌薬物検査サービスの開発に取り組んでいます。`,
      investmentDemand: '業務提携、資本提携',
      established: '2018',
      capitalInvestment: '2,000万台湾ドル（約7,200万円）',
      employees: '--',
      revenue: '約4,700万円',
    },
    {
      image: 'logo.png',
      tag: '#自動化 #B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド完了した',
      number: 'SLTW003',
      companyName: '誰でも生産工程の自動化ソフトウェアを作成できるようにする',
      description: `
      ファクトリーオートメーション向けのソフトウェア開発会社として、
      当社のパートナーのための多数のプラットフォーム間で
      そのユーザーとドライブ成長にさわやかな新しい視点を提供し、
      より多様なアプリケーションのアプローチを強調することで、
      自動化ソフトウェアモデルに革命をもたらしてきました。`,
      investmentDemand: '販売提携、生産提携',
      established: '2015',
      capitalInvestment: '600万台湾ドル（約2,190万円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド完了した',
      number: 'SLTW004',
      companyName: '骨格分析技術を通じで保安システムのベストソリューションを提供する',
      description: `
      AIセキュリティカメラの映像分析サービスプラットフォームを提供しております。
      4000点人体シルエットの特徴点を分析して、長距離で伝統的な顔認識システムより30％以上の認識率が高いです。`,
      investmentDemand: '資本提携、業務提携',
      established: '2013',
      capitalInvestment: '3.25億台湾ドル（約11.8億円）',
      employees: '31~50',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B #B2B2CC',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド調達中',
      number: 'SLTW005',
      companyName: '小売業向けのAIツールプラットフォーム',
      description: '未公開',
      investmentDemand: '業務提携',
      established: '2017',
      capitalInvestment: '88万台湾ドル（約320万円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：アメリカ',
      investmentStatus: 'Aラウンド完了した',
      number: 'SLTW006',
      companyName: '機器学習及び計算機科学の技術が企業の方に広がって浸透するように',
      description: `
      各分野のプロの専門知識を活かしたより
      効率的なデータ処理で自動化機械学習をさらに進化させています。
      各データの特性に精通した予測モジュールだからこそ、
      短時間で膨大なデータから最も価値あるものを抽出することができます。`,
      investmentDemand: '資本提携、業務提携',
      established: '2015',
      capitalInvestment: '15.7億台湾ドル（約57.3億円）',
      employees: '51~100',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド完了した',
      number: 'SLTW007',
      companyName: '放送業界における著作権問題をAI作曲で解決します',
      description: `ビッグデータ、AIインテリジェンス、伝統的な音楽制作会社、
      レコード会社、著作権会社、音楽人、ビデオ、音楽ストリーミングプラットフォームとの提携により、
      音楽制作のインスピレーションと無料の著作権ライセンスを提供します。`,
      investmentDemand: '業務提携、資本提携',
      established: '2018',
      capitalInvestment: '300万台湾ドル（約1,090万円）',
      employees: '11~30',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW008',
      // companyName: '工程生產力雲服務 :新世代建築專案管理軟體(SaaS)',
      companyName: '工事クラウドサービス:建物プロジェクト管理ソフトウェア(SaaS)',
      // description: `
      // 讓工程建案的管理團隊能即時在線上協作，溝通，管理建案資料，
      // 實現智慧工程（雲端化+數位化+行動化），將建案工地現場所有訊息變成線上可視化。
      // 精準的溝通能提升工作效率，節省時間，減少錯誤，整體減少營造風險與增加公司競爭力。`,
      description: `
      エンジニアリングプロジェクト管理チームがリアルタイムでオンラインで共同作業し、コミュニケーションを行い、
      プロジェクトデータを管理し、インテリジェントエンジニアリング(クラウド+デジタル+モバイル)を実現し、\
      建設現場のすべての情報をオンライン可視化します。正確なコミュニケーションは、生産性を高め、
      時間を節約し、エラーを減らし、全体的なリスクを低減し、企業の競争力を高めます。`,
      investmentDemand: '業務提携、資本提携',
      established: '2015',
      capitalInvestment: '1,200万台湾ドル（約4,380万円）',
      employees: '5',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW009',
      // companyName: '紡織數位化SaaS雲端平台，創建與管理你的紡織資料庫。',
      companyName: 'テキスタイルデジタルSaaSクラウドプラットフォームは、テキスタイルデータベースを作成および管理します。',
      // description: `針對紡織物所提供的SaaS雲端協作平台，
      // 利用 AI 為服裝業構建世界上最好的紡織品織物圖像交換系統。
      // 已驗證可以確實解決傳統面料供應鍊和業務實踐中的流程效率低下狀況，
      // 為服裝業帶來革新的改變。`,
      description: `繊維製品のためのSaaSクラウドコラボレーションプラットフォームは、AIを使用して、
      アパレル業界のための世界最高の繊維ファブリック画像交換システムを構築します。
      従来の生地供給精製やビジネス慣行におけるプロセスの非効率性に対処し、
      アパレル業界に新たな変化をもたらすことが確認されています。`,
      investmentDemand: '資本提携、業務提携',
      established: '2019',
      capitalInvestment: '500万台湾ドル（約1,800万円）',
      employees: '10',
      revenue: '約720万円',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド調達中',
      number: 'SLTW010',
      // 利用AI深度學習應用於教育業的智能分析平台
      companyName: 'AIディープラーニングを教育業界向けのインテリジェントな分析プラットフォームに活用します',
      // 1.深度學習:神經網絡料、自主搜尋母體資料、自主擷取特徵解決答案
      // 2.智能分析:大數據庫、自動資料前處理、搜尋最佳化模組、自動參數篩選、產生評估報表
      // 3.適性化模組:大學學習歷程核心資料參數、系所往年錄取人數及分數原始參數、學生個人特質及能力 加權參數
      description: `1.ディープラーニング:ニューラルネットワーク材料、親データの自律検索、特性解決のための自律的な抽出
      2.インテリジェントな分析:大規模なデータベース、自動データ前処理、検索最適化モジュール、自動パラメータフィルタリング、評価レポートの生成
      3.適合モジュール:大学学習コースのコアデータパラメータ、学部の過去の入学者数とスコアの元のパラメータ、学生の個人的な特性と能力加重パラメータ`,
      investmentDemand: '資本提携、業務提携',
      established: '2016',
      capitalInvestment: '100万台湾ドル（約360万円）',
      employees: '10~15',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'Pre-A+ラウンド調達中',
      number: 'SLTW011',
      companyName: '自動マイクロ画像認識システムクラウドサーバー',
      // 透過最新研發之自動顯微鏡在客戶端取像，
      // 在雲端進行大數據分析，進行癌症與疾病的偵測與篩檢，
      //
      // 自動化顯微影像辨識系統與雲端伺服器，可有效提升臨床檢驗品質。
      //
      // 智慧醫學顯微鏡能快速執行生物體染色自動化讀取，提升人工鏡檢的工作效率及檢出率。
      //
      // 結合雲端技術可用於各種檢驗，提供精準的檢測分析。
      description: `
      最新の自動顕微鏡でクライアントで撮影し、クラウドでのビッグデータ分析、がんや病気の検出とスクリーニング、
      自動顕微鏡画像識別システムとクラウドサーバにより、臨床検査の品質を効果的に向上させることができます。
      インテリジェントな医療顕微鏡は、生体染色の自動読み取りを迅速に実行し、人工鏡検査の効率と検出率を向上させます。
      クラウド技術と組み合わせることで、さまざまな検査に使用され、正確な検査分析を提供します。`,
      investmentDemand: '販売提携、業務提携',
      established: '2016',
      capitalInvestment: '7,600万台湾ドル（約2.736億万円）',
      employees: '14',
      revenue: '約5,400万円',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'Aラウンド調達中',
      number: 'SLTW012',
      // 物聯網能源監測系統，提升工廠製程效能的最佳協助工具。
      companyName: 'IoTエネルギー監視システムは、プラントプロセスのパフォーマンスを向上させる最高の支援ツールです',
      // 提供容易設定及建置的EMS能源監測系統，
      // 整合開放的通訊協議和專利身份認證的安全網路架構，
      // 讓用電狀況可視化，進而分析/管理/控制，增進能源效率。
      description: `EMSエネルギー監視システムの設定と構築が容易で、
      オープンな通信プロトコルと特許取得済みの認証のための安全なネットワークアーキテクチャを統合し、
      電力使用状況を視覚化し、分析/管理/制御を行い、エネルギー効率を向上させます。`,
      investmentDemand: '業務提携、資本提携',
      established: '2015',
      capitalInvestment: '3,400万台湾ドル（約1.2億円）',
      employees: '5~10',
      revenue: '約1,800万円',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：ケイマン諸島',
      investmentStatus: 'Pre-Aラウンド調達中',
      number: 'SLTW013',
      // 全球智慧汽車解決方案提供商之中唯一具備自主框架的AI公司
      companyName: 'スマートカーソリューションプロバイダーの中で、自律的なフレームワークを持つ唯一のAI企業',
      // • 自主研發深度學習 AI 訓練框架，相對於GPU、FPGA、TPU等，輕量化後的AI模型
      // 提供最低的成本和應用於不同平台的靈活度。
      // • 提供車廠標準化的 AI 設計套件，讓車廠得以在 Cockpit/ADAS domain 上輕鬆開發和設計，
      // 節省車廠 1/3 以上的開發成本和時間。
      // • 創新的 HMI 和 ADAS 核心技術及專利組合
      // • 連續三年(2018-2020)榮獲 4 座美國 CES Innovation Award
      description: `
      • GPU、FPGA、TPUなどに対して、軽量のAIモデルが最小限のコストとさまざまなプラットフォームに
      適用できる柔軟性を提供するディープラーニングAIトレーニングフレームワークを独自に開発。
      • Cockpit/ADAS domain で簡単に開発および設計できる、自動車メーカーの標準化された AI 設計
      スイートを提供し、工場の開発コストと時間を 3 分の 1 以上節約します。
      • 革新的なHMIとADASのコアテクノロジーと特許ポートフォリオ
      •3年連続(2018-2020)は、4つの米国CES Innovation Awardを受賞しました`,
      investmentDemand: '資本提携、業務提携',
      established: '2017',
      capitalInvestment: '100万米ドル（約1億円）',
      employees: '30',
      revenue: '約3.8億円',
    },
    {
      image: 'logo.png',
      tag: '#B2B #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'Pre-Aラウンド調達中',
      number: 'SLTW014',
      // 無人機市場專業研發製造商及多旋翼無人機系統研發製造領先者。
      companyName: 'ドローン市場の専門R&Dメーカーとマルチロータードローンシステムの研究開発と製造のリーダー。',
      // 自主開發完成多軸旋翼機飛控系統、導控地面站軟體設計及無人機人工智慧系統管理系統。
      //
      // 客戶包含政府機關、海外企業用戶及各級研究單位
      // 應用技術領域包含建築檢測與測繪、無人機農業應用科技與物流技術開發等。
      //
      // 在無人機巡檢的應用，搭配自有的導控軟體更能將檢測的程序自動化，
      // 可以提升檢測效率並縮短檢測時間以減少人力的依賴度。
      //
      // 未來將以人工智慧辨識技術，加強即時辨識的高效巡檢功能。
      description: `多軸ローターの飛行制御システム、地上局のソフトウェア設計、ドローン人工知能システム管理システムの独立した開発と完了。
      クライアントには、政府機関、海外企業ユーザー、およびあらゆるレベルの研究ユニットが含まれる
      応用技術分野には、建築検査・マッピング、ドローン農業応用技術、物流技術開発などがあります。

      ドローンパトロールアプリケーションでは、独自のパイロットソフトウェアと組み合わせて検査手順を自動化し、検査効率を向上させ、検査時間を短縮し、人的依存を低減します。

      将来的には、人工知能認識技術により、リアルタイム認識のための効率的な検査機能が強化されます。`,
      investmentDemand: '戰略性投資、廣告行銷、通路代理商、技術合作',
      established: '2015',
      capitalInvestment: '3,200万台湾ドル（約1.15億円）',
      employees: '15',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B #B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'Pre-Aラウンド調達中',
      number: 'SLTW015',
      // 電動車智慧充電服務系統
      companyName: '電気自動車のスマート充電サービスシステム',
      // 電力管理與充電服務營運商
      // 1. 電動汽車充電管理服務:電動汽車充電特約好夥伴，不論居家還商辦，都有完善管理方案。
      // 免抄表、契約容量不超約，電費分拆一目瞭然，充電站收費管理一點也不難。
      // 2. 智慧建築能源管理系統:不論住家、集合式住宅、餐廳或工廠，
      // 即時掌握用電情形，電費最省。透過 AI 演算法，
      // 精算最適電費方案與契約容量，建立監控模型，設備異常即時知。
      description: `電力管理および充電サービス事業者
      1.電気自動車充電管理サービス:電気自動車の充電は、良好なパートナーであり、家庭や商業に関係なく、
      完璧な管理プログラムを持っています。 メーターの読み取りフリー、契約容量は、電気料金のスピンオフが一目で、
      充電ステーションの料金管理は、すべての困難ではありません。
      2.スマートビルディングエネルギー管理システム:家庭、集合住宅、レストラン、工場に関係なく、
      電気の使用状況をリアルタイムで把握し、電気代を最も節約します。 AIアルゴリズムを使用して、
      最適な電気料金スキームと契約容量を数え、監視モデルを確立し、機器が異常にリアルタイムで認識されます。`,
      investmentDemand: '資本提携、業務提携',
      established: '2015',
      capitalInvestment: '2,400万台湾ドル（約8,640万円）',
      employees: '10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B #B2C #B2G',
      location: '本社所在地：台灣',
      investmentStatus: 'Pre-Aラウンド調達中',
      number: 'SLTW016',
      // 專注於 AI 人工智慧與 Robotics 智能機器人的開發及研發能力。
      companyName: 'AI人工知能とロボティクス知能ロボットの開発・研究開発能力に注力。',
      // 提供的學習內容以英文教學與程式編寫為主，產品結合學習內容與AI技術, 讓AI機器人提供即時回饋、易懂的學習介面及內容等多元學習的方式。
      description: `英語教育やプログラム作成を中心とした学習コンテンツを提供し、
      学習コンテンツとAI技術を組み合わせて、AIロボットがリアルタイムフィードバック、
      理解しやすい学習インターフェース、コンテンツなど、多様な学習方法を提供します。`,
      investmentDemand: '資本提携、業務提携',
      established: '2016',
      capitalInvestment: '5.2億台湾ドル（約18.72億円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'Pre-Aラウンド調達中',
      number: 'SLTW017',
      // 創造有趣和互動的內容，將運動帶進人們的相處裡
      companyName: '楽しさとインタラクティブなコンテンツを作成し、人々の生活に動きを取ります',
      // 透過技術來實現人們在不同地方卻能一起運動的交互式健身解決方案，
      // 在任何公共場所都能連接到虛擬環境，也能簡單與 SmartTV，家用筆記本電腦，互聯網機頂盒或手機進行串接。
      // 成為每個人都能負擔得起的交互式健身解決方案的提供商。
      description: `
      テクノロジーは、人々がさまざまな場所で一緒に動くインタラクティブなフィットネスソリューションを実現し、
      あらゆる公共の場所で仮想環境に接続し、SmartTV、家庭用ラップトップ、インターネットセットトップボックス、
      または携帯電話と簡単に接続することができます。
      誰もが手頃な価格でインタラクティブなフィットネスソリューションのプロバイダになります。`,
      investmentDemand: '資本提携、業務提携',
      established: '2019',
      capitalInvestment: '500万台湾ドル（約1,800万円）',
      employees: '10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'Aラウンド調達中',
      number: 'SLTW018',
      // 停車服務 SaaS 平台：解決停車位不足、難找費時的問題，更為車位主帶來額外收益'
      companyName: '駐車場サービスSaaSプラットフォーム',
      // 共享車位媒合平台，讓私人車位在不被使用的空檔能暫時出租給有臨時停車需求的駕駛，不僅解決停車位不足、難找費時的問題，更為車位主帶來額外收益的雙贏。
      description: `共有駐車スペースメディアプラットフォームは、プライベート駐車スペースが
      一時的な駐車需要を持つ運転に一時的にリースできるようにし、駐車スペースの不足、
      時間の問題を見つけるのが難しいだけでなく、駐車スペースの所有者は、ウィンウィンの余分な利益をもたらします。`,
      investmentDemand: '資本提携、業務提携',
      established: '2016',
      capitalInvestment: '4,400万台湾ドル（約1.58億円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'シードラウンド調達中',
      number: 'SLTW019',
      // 專注於臨床微生物基因檢測之創新公司
      companyName: '臨床微生物遺伝子検査に特有の革新的な企業',
      // 透過有專利的高分子生物材料結合病原體即時基因定序檢測方法，製造出獨家專利的薄膜技術
      // 推動基因定序技術在臨床微生物領域的應用和對傳統技術的升級更新，真正能夠滿足臨床需求的微生物定序檢測產品。
      description: `
      特許取得済みの高分子生体材料と病原体のリアルタイム遺伝子シーケンシング検出により、特許取得済みの薄膜技術が製造されています。
      臨床微生物分野における遺伝子シーケンシング技術の応用と従来の技術のアップグレードを促進し、臨床ニーズを満たすことができる微生物シーケンシング検査製品。`,
      investmentDemand: '資本提携、業務提携',
      established: '2020',
      capitalInvestment: '2500万台湾ドル（約9000万円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: '未公開',
      number: 'SLTW020',
      // 透過分析不確定性的訊息，掌握潛在商機的AI大數據技術
      companyName: '不確実性のメッセージを分析し、潜在的なビジネスチャンスを把握するAIビッグデータ技術',
      // 四項主要事業：財經股市、專利分析、智慧零售、資訊安全。
      // 目前針對金融界提供股票AI的服務，提供股市及產業的預測分析，輔助大眾進行投資決策。
      description: `4つの主な事業:金融株式市場、特許分析、スマート小売、情報セキュリティ。
      現在、金融業界向けの株式AIサービスを提供し、株式市場や産業の予測分析を提供し、投資判断を支援しています。`,
      investmentDemand: '業務提携、資本提携',
      established: '2017',
      capitalInvestment: '1.2億台湾ドル（約4.32億円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: '未公開',
      number: 'SLTW021',
      // 提供嵌入式系統軟韌體設計、AI 演算法開發及雲端架構平台設計
      companyName: '組込みシステムのソフトファームウェア設計、AIアルゴリズム開発、クラウドアーキテクチャプラットフォーム設計を提供します',
      // 技術項目包含：Edge AI 邊緣運算系統軟韌體設計、手機軟體設計、演算法開發設計(語音辨識/噪音消除)、物聯網系統(雲端架構)。
      // 產品/服務應用領域：筆電軸承聲音訊號自動監測系統、馬達振動偵測與故障判斷
      description: `技術プロジェクトには、Edge AIエッジコンピューティングシステムのソフトファームウェア設計、
      携帯電話ソフトウェア設計、アルゴリズム開発設計(音声認識/ノイズ除去)、
      IoTシステム(クラウドアーキテクチャ)が含まれます。
      製品/サービスアプリケーション:ペンベアリング音声信号自動監視システム、モータ振動検出と故障判定`,
      investmentDemand: '業務提携',
      established: '2015',
      capitalInvestment: '1,700万台湾ドル（約6,120万円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'Aラウンド完了した',
      number: 'SLTW022',
      // 3D 感測及Edge-AI技術，全球領先的3D視覺與人工智能的解決方案
      companyName: '3DセンシングとEdge-AIテクノロジーは、世界をリードする3Dビジョンと人工知能ソリューションです',
      // 設計、開發並製造 3D 深度攝影機，針對客戶需求提供多種類的3D AI軟體與應用。
      // 我們提供 End-to-End 的 3D 視覺與 Edge-AI 解決方案，可以因應每個產業的客戶需求。
      description: `3D深度カメラを設計、開発、製造し、お客様のニーズに合わせてさまざまな3D AIソフトウェアとアプリケーションを提供します。
      End-to-Endの3DビジョンおよびエッジAIソリューションを提供し、あらゆる業界のお客様のニーズにお応えします。`,
      investmentDemand: '業務提携',
      established: '2014',
      capitalInvestment: '2.4億台湾ドル（約8.64億円）',
      employees: '90',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：ケイマン諸島',
      investmentStatus: 'Pre-Aラウンド完了した',
      number: 'SLTW023',
      // 透過大數據在高效能運算的密集加速，增強並推進科學探索與科技研究
      companyName: 'ビッグデータによる効率的なコンピューティングの集中的な加速により、科学探査と科学研究を強化し、推進します',
      // 提供在 Big data 軟硬體整合優化解決方案。核心技術為大數據資料處理加速引擎，包含優化資料處理程式，以及大數據資料處理專用加速晶片平台(FPGA)，擁有軟硬整合技術。
      // 1. 大幅提升資料處理分析效能，對於節能以及營運成本的降低有顯著的效果。
      // 2. 對於 IC 設計、分散式軟硬體協同運算以及伺服器產業有深厚的技術知識。
      // 3. 關鍵字搜索和鍵值排序的運算速度提高 6 倍以上。
      description: `
      Big data のハードウェアとソフトウェアの統合最適化ソリューションを提供します。
      コア技術は、最適化されたデータ処理プログラムと、ハードとソフトの統合技術を備えたビッグデータデータ
      処理専用アクセラレーションチッププラットフォーム(FPGA)を含むビッグデータデータ処理アクセラレーションエンジンです。
      1. データ処理分析の効率を大幅に向上させ、省エネルギーと運用コストの削減に大きく貢献します。
      2. IC設計、分散ハードウェアとソフトウェアの協調演算、およびサーバー業界に関する深い技術的知識。
      3. キーワード検索とキー値の並べ替えの演算速度が 6 倍以上向上しました。`,
      investmentDemand: '業務提携、資本提携',
      established: '2015',
      capitalInvestment: '1,000万台湾ドル（約3,600万円）',
      employees: '10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド完了した',
      number: 'SLTW024',
      // 最簡單易用的區塊鏈履歷與證書服務
      companyName: '最も使いやすいブロックチェーン履歴と証明書サービス',
      // 透過區塊鏈不可篡改、可追溯、成本節省、跨國界的優勢，重新定義傳統教育認證，創造穩定且永久的學習履歷追蹤，保證用戶絕對的資料掌控權與隱私，強化官方權威證書的最高信任與價值。
      // 1. 個人學習歷程追溯
      // 2. W3C DID 去中心身份協定
      // 3. GDPR 最高隱私保留演算法
      description: `ブロックチェーンの改ざん不能、トレーサビリティ、コスト削減、
      国境を越えた利点により、従来の教育認証を再定義し、安定的かつ永続的な学習履歴追跡を作成し、
      ユーザーの絶対的なデータ管理とプライバシーを確保し、公的機関の信頼と価値を高めます。
      1. 個人的な学習履歴のトレーサビリティ
      2.W3C DID は中央 ID プロトコルに移動します
      3.GDPRの最高プライバシー保持アルゴリズム`,
      investmentDemand: '業務提携',
      established: '2020',
      capitalInvestment: '100万台湾ドル（約360万円）',
      employees: '--',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW025',
      companyName: '適切なソフトウェア アプリケーションと関連する経験を持つ開発者を見つけ、より迅速かつ簡単に見つけることができます',
      // 軟體開發線上交易社群平台，幫助軟體開發者增加收入及改變傳統軟體商品銷售模式，讓客戶快速找到合適的軟體解決方案。
      description: `ソフトウェア開発オンライントレーディングコミュニティプラットフォームは、
      ソフトウェア開発者が収益を増やし、従来のソフトウェア商品販売モデルを変更し、
      お客様が適切なソフトウェアソリューションを迅速に見つけるのに役立ちます。`,
      investmentDemand: '業務提携',
      established: '2019',
      capitalInvestment: '120万台湾ドル（約432万円）',
      employees: '5~10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW026',
      // 將昆蟲產品的製造模組化概念廣泛到世界各地，達到「在地生產、在地行銷」的願景
      companyName: '昆虫製品の製造モジュラーコンセプトを世界中に広く展開し、生産とマーケティングのビジョンを実現します',
      // 利用黑水虻製作動物性蛋白，提供畜產飼料優質的蛋白質來源，
      // 遵循歐盟及美國 AAFCO 的標準程進行飼養。
      // 將來自天然農業副產物(酒糟、豆渣及鳳梨皮等)植物性原料進行餌料配置及飼養，以達到國 飼料昆蟲養殖之法規。
      description: `動物性タンパク質は、欧州連合(EU)および米国AAFCOの標準手順に従って飼育され、
      家畜飼料の高品質のタンパク質源を提供するために、ブラックウォーターポアから製造されています。
      天然農業副産物(酒かす、豆かす、パイナップルの皮など)からの植物性原料を餌として配置・飼育し、国の飼料昆虫養殖法を制定する。`,
      investmentDemand: '業務提携、資本提携',
      established: '2019',
      capitalInvestment: '1,250万台湾ドル（約4,500万円）',
      employees: '5~10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW027',
      // 量身訂做新生骨，解決人工骨的缺點
      companyName: '人工骨の欠点を解決するために、オーダーメイドの新生骨を提供します',
      // 可注射式人工骨適用於填充骨缺損、強度足以支撐患部來避免凹陷，在癒合期間可被人體吸收置換為新生骨。醫療級原料：純度高，生物相容性高，毒性低，無致癌性。
      description: `注射可能な人工骨は、骨欠損を充填するのに適し、
      くぼみを避けるために患部を支えるのに十分な強度を有し、
      治癒中に新生骨に吸収され、置換することができる。
      医療グレードの原料:高純度、高い生物学的互換性、低毒性、発癌性なし。`,
      investmentDemand: '資本提携、業務提携',
      established: '2017',
      capitalInvestment: '4,100万台湾ドル（約1.476億円）',
      employees: '10~20',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW028',
      // 結合跨領域檢測與智能方法，從高光譜數據中提取有價值性的信息
      companyName: 'クロスドメイン検出とインテリジェントなアプローチを組み合わせることで、ハイスペクトルデータから貴重な情報を抽出します',
      // 自家開發的高光譜影像技術建構智能辨識系統，可應用於各個產業領域。
      // ◎製造業：以高光譜影像技術，搭配人工智能演算及影像感測模組，升級現有設備。
      // ◎醫療業Ｌ智能助手，動態影像即時反饋提供醫生診斷訊息完成遠距醫療，以手機 APP 提供診斷輔助
      description: `独自に開発したハイスペクトル画像技術は、インテリジェント識別システムを構築し、様々な産業分野に応用できます。
      •製造:高度なスペクトルイメージング技術、人工知能演算と画像センシングモジュールと組み合わせて、既存の機器をアップグレードします。
      •医療業界Lスマートアシスタント、動画像インスタントフィードバックは、遠隔医療を完了するために医師の診断メッセージを提供し、携帯電話のAPPで診断支援を提供します。`,
      investmentDemand: '資本提携、業務提携',
      established: '2020',
      capitalInvestment: '1,500万台湾ドル（約5,400万円）',
      employees: '5~10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW029',
      companyName: '液体材料は電子顕微鏡の直接検出の解決である',
      // 隨 IC 製程往更小尺寸(N7→N5→N3)發展，結構與材料複雜度增加，研磨液檢測需求量急增。
      // 提供液態材料於電子顯微鏡的檢測產品、檢測服務、代工服務、RD 服務。
      // 半導體大廠可以避免因 CMP 研磨液(Slurry)材料品質問題，使良率無法提升，
      // 無法穩定每個月的產量，或因光阻劑品質異常，生產線場沒有即時發現異狀、導致損失。
      description: `ICプロセスが小型(N7→N5→N3)に発展するにつれ、構造や材料の複雑さが増し、研磨液の検出需要が急増しています。
      電子顕微鏡検査製品、検査サービス、バインサービス、RDサービスに液体材料を提供します。
      半導体工場は、CMP研磨液の材料品質の問題を回避し、良いレートを上昇させることができない、
      毎月の生産量を安定させることができないか、フォトレジストの品質が異常な場合、
      生産ラインフィールドは、すぐに異常を検出し、損失を引き起こしません。`,
      investmentDemand: '業務提携',
      established: '2019',
      capitalInvestment: '100万台湾ドル（約360万円）',
      employees: '5~10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2CC',
      location: '本社所在地：台灣',
      investmentStatus: 'アーリーラウンド調達中',
      number: 'SLTW030',
      // 新世代微儲能，打造智慧能源生態圈
      companyName: '新世代のマイクロエネルギー貯蔵は、スマートエネルギーエコシステムを構築します',
      // 團隊擁有 20 年以上電池保護板專業經驗，專注於各式電池組的開發及設計。
      // 產品涵蓋各型號鋰離子電池及相關運用：筆記型電腦電池、數位攝影機電池、相機電池、工具類電池、玩具電池、儀器器設備電池 及手錶電池等。
      // 提供小眾市場與客制化訂做, 並隨時提供最佳之技術諮詢與維修服務。
      // 以高品質產品滿足客戶的需求，產品遠銷國外遍佈歐洲、美洲、亞洲多個國家與地區。
      description: ` チームは、バッテリー保護ボードの20年以上の専門的な経験を持ち、様々なバッテリーパックの開発と設計に重点を置いています。
      製品は、リチウムイオン電池および関連アプリケーションのすべてのモデルをカバーしています：
      ノートパソコンのバッテリー、デジタルカメラバッテリー、カメラバッテリー、ツールバッテリー、おもちゃのバッテリー、計器機器バッテリーと時計バッテリーなど。
      小さな市場とオーダーメイドのオーダーメイドを提供し、常に最高の技術アドバイスとメンテナンスサービスを提供します。
      高品質の製品は、顧客のニーズを満たすために、製品は、ヨーロッパ、アメリカ、アジアの多くの国と地域に海外に輸出されています。`,
      investmentDemand: '業務提携、技術提携',
      established: '2014',
      capitalInvestment: '500万台湾ドル（約1800万円）',
      employees: '10',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C',
      location: '本社所在地：台灣',
      investmentStatus: 'Aラウンド完了した',
      number: 'SLTW031',
      // 成為亞洲最大的英語Edtech公司
      companyName: 'アジア最大の英語Edtech企業となるのを狙う',
      description: `動画を活用した英語学習のEdTechを提供しております。
      Facebookのスタートアップコンテストでアプリ・オ ブ・ザ・イヤーの最優秀賞を受賞し、2016年には日本で様々なメディアに紹介されました。今年からAI新機能を活用したサービスで日本のEdTech市場に市場展開しております!`,
      investmentDemand: '業務提携、資本提携',
      established: '2012',
      capitalInvestment: '8000万台湾ドル（約2.88億円）',
      employees: '70',
      revenue: '未公開',
    },
    {
      image: 'logo.png',
      tag: '#B2C #B2B2C #B2B',
      location: '本社所在地：台灣',
      investmentStatus: 'Aラウンド完了した',
      number: 'SLTW032',
      companyName: '世界のダウンロード数は2億人を超え、最高のソフトウェアアプリケーションを提供するSaaSソフトウェア開発会社',
      description: `創業以来、ビジネスとクリエイティブ制作の場において、生産性を高め、
      創造性をより発揮できるようなオンラインサービスとモバイルソフトウェアアプリケーションを開発してきました。
      現在、製品は世界167カ国に展開し、2億以上ダウンロードされています。台湾に本社を置き、中国、米国に展開、そして日本にも展開しています。`,
      investmentDemand: '業務提携、資本提携',
      established: '2009',
      capitalInvestment: '8000万台湾ドル（約2.88億円）',
      employees: '70',
      revenue: '未公開',
    },
  ]

  private changeMessage() {
    this.msg = 'MESSAGE CHANGED';
  }
}
